module.exports = __webpack_public_path__ + "img/04.e0c4c37e.png";